import { useLocation } from "react-router-dom";

import { asLocation } from "seneca-common/utils/routing";
import { Link } from "common/types/routing";

import { ActivateTutoringJourneyParamKey, Stage } from "../consts";

type Options = {
  stage?: Stage;
  location?: Link;
};

export function useTutoringActivationJourneyLink({
  stage = Stage.Start,
  location
}: Options = {}) {
  const locationFromContext = useLocation();

  const baseLocation = asLocation(location) || locationFromContext;

  const params = new URLSearchParams(baseLocation && baseLocation.search);
  params.set(ActivateTutoringJourneyParamKey, stage);

  return {
    ...baseLocation,
    search: params.toString()
  };
}
